import * as types from 'constants/actionTypes';
import * as operationsApi from 'api/operationsApi';
import { beginAjaxCall, ajaxCallError } from './ajaxCallActions.js';

export function getCubs() {
  return function(dispatch) {
    dispatch(beginAjaxCall());
    return operationsApi
      .getCubs()
      .then(
        response => dispatch(getCubSuccess(response)),
        error => dispatch(ajaxCallError())
      );
  };
}

export function createNewCub(cub) {
  return function(dispatch, getState) {
    dispatch(beginAjaxCall());
    return operationsApi
      .createNewCub(cub)
      .then(response => response, error => dispatch(ajaxCallError()));
  };
}

export function updateCub(cub) {
  return function(dispatch, getState) {
    dispatch(beginAjaxCall());
    return operationsApi
      .updateCub(cub)
      .then(response => response, error => dispatch(ajaxCallError()));
  };
}


function getCubSuccess(response) {
  return {
    type: types.GET_CUBS_SUCCESS,
    cubs: response.data || ["Nothinghere", "OrHere"]
  };
}